import AdminSection, { humanize } from "./AdminSection";

const SOURCES = [
  { value: "contact_form", label: "Contact Form" },
  { value: "chatbox", label: "Chatbox" },
];

const sourceLabel = (r) => {
  const s = r.source || "contact_form";
  return SOURCES.find((x) => x.value === s)?.label || humanize(s);
};

const config = {
  title: "Inbox",
  path: "inbox",
  statuses: ["new", "read", "responded", "follow_up_needed", "closed"],
  extraFilters: [{ key: "source", label: "sources", options: SOURCES }],
  columns: [
    { key: "created_at", label: "Submitted", render: (r) => new Date(r.created_at).toLocaleString() },
    { key: "name", label: "From", render: (r) => `${r.first_name}${r.last_name ? ` ${r.last_name}` : ""}` },
    { key: "email", label: "Email" },
    { key: "subject", label: "Subject", render: (r) => r.subject || "—" },
    { key: "source", label: "Source", render: sourceLabel },
    { key: "status", label: "Status" },
  ],
  detailFields: [
    { key: "email", label: "Email" }, { key: "phone", label: "Phone" }, { key: "organization", label: "Organization" },
    { key: "subject", label: "Subject" }, { key: "message", label: "Message" },
    { key: "source", label: "Source", render: sourceLabel },
    { key: "created_at", label: "Submitted", render: (r) => new Date(r.created_at).toLocaleString() },
  ],
};

export default function AdminInbox() { return <AdminSection config={config} />; }
